export default function ({$echo, app}) {
  Pusher.Runtime.createXHR = function () {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    return xhr;
  };

  $echo.connect();
}
